/**
* In this file used to hande table paginations
**/
import ReactPaginate from 'react-paginate';
import { useTranslation } from 'react-i18next';

/**
* @page pass the page count
* @total pass the total record count
* @handlePaginate is a call back function
* @limit pass the limit value for per page
**/
const Paginate = ({page,total,handlePaginate,limit}) => {
	const { t } = useTranslation();
	/** To handle NEXT and PREV event **/
	const handlePageClick=(e)=>{
		handlePaginate(e.selected)
	}
	const role = Number(localStorage.getItem('role'));
  return (
    <ReactPaginate
        previousLabel={t('profile.prev')}
        nextLabel={t('profile.next')}
        pageCount={Math.ceil(total / (limit ? limit : 10))}
        breakClassName={'page-item'}
		 onPageChange={handlePageClick}
		 breakLinkClassName={`page-link ${role === 4 ? 'admin-page-link' : ''}`}
		 containerClassName={'pagination'}
		 pageClassName={'page-item'}
		 pageLinkClassName={`page-link ${role === 4 ? 'admin-page-link' : ''}`}
		 previousClassName={'page-item'}
		 previousLinkClassName={`page-link ${role === 4 ? 'admin-page-link' : ''}`}
		 nextClassName={'page-item'}
		 nextLinkClassName={`page-link ${role === 4 ? 'admin-page-link' : ''}`}
		 activeClassName={'active'}
      />
  );
	
};

export default Paginate;